import {Component, ContentChildren, Input, OnInit, QueryList} from '@angular/core';
import {AccordionPanelHeaderComponent} from "../accordion-panel-header/accordion-panel-header.component";

@Component({
  selector: 'ui-accordion-panel',
  template: `<div class="card">
  <div class="card-header" [attr.id]="'heading'+index">
    <h5 class="mb-0">
      <a     data-toggle="collapse" [attr.data-target]="'#collapse'+index"
              [attr.aria-expanded]="isOpen" [attr.aria-controls]="'collapse'+index" (click)="toggle(index)">
        <span class="ui-accordion-header-text" *ngIf="!hasHeader">
          {{header}}
        </span>
        <ng-content select="ui-accordion-panel-header" *ngIf="hasHeader"></ng-content>
      </a>
    </h5>
  </div>
  <div [attr.id]="'collapse'+index" class="collapse " [ngClass]="{'show':isOpen}"
       [attr.aria-labelledby]="'heading'+index" data-parent="#accordionExample">
    <div class="card-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
`,
  styles: [``]
})
export class AccordionPanelComponent implements OnInit {
  @Input() header;
  @Input() isOpen;
  index;
  @ContentChildren(AccordionPanelHeaderComponent) headerComponent: QueryList<AccordionPanelHeaderComponent>;
  constructor() {
  }
  get hasHeader(): boolean {
    return this.headerComponent && this.headerComponent.length > 0;
  }
  ngOnInit() {
    this.index = Math.ceil(1000 * Math.random());
  }

  toggle(i) {
    this.isOpen = !this.isOpen ;
  }

}
